module.exports = __webpack_public_path__ + "img/madeira.1fedbdc6.svg";